import React, {Component} from 'react';

class If extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        return this.props.condition ?
            this.props.children : null;
    }
}

export default If;
